import React from "react";
import Header from "../shared/header";
import { Box } from "@mui/material";

/**
 * A component that displays the parameters page header.
 * Features include:
 * - Page title
 * - Welcome subtitle in German
 * - Responsive layout
 * - Consistent styling with other pages
 * 
 * @component
 * @returns {JSX.Element} The rendered parameters page header
 * 
 * @example
 * ```tsx
 * <ParametersPage />
 * ```
 */
const ParametersPage = () => {
  return (
    <Box ml="20px" mt="65px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="PARAMETERS" subtitle="Willkommen bei Ihren Parametern" />
      </Box>
    </Box>
  );
};

export default ParametersPage;
